import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PinInvokeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pin_invoke"}/>
}
